import { render, staticRenderFns } from "./RFM_custom_analysis.vue?vue&type=template&id=01fc4fe6&scoped=true"
import script from "./RFM_custom_analysis.vue?vue&type=script&lang=js"
export * from "./RFM_custom_analysis.vue?vue&type=script&lang=js"
import style0 from "./RFM_custom_analysis.vue?vue&type=style&index=0&id=01fc4fe6&prod&lang=scss"
import style1 from "./RFM_custom_analysis.vue?vue&type=style&index=1&id=01fc4fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc4fe6",
  null
  
)

export default component.exports